export default "__VITE_ASSET__BlW98Cs4__"